// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"211":"954c0e15","340":"1124c51e","406":"635facca"}[chunkId] + ".chunk.css";
};